import { render, staticRenderFns } from "./FinaliseMoneyClaim.vue?vue&type=template&id=18672028&"
import script from "./FinaliseMoneyClaim.vue?vue&type=script&lang=js&"
export * from "./FinaliseMoneyClaim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports